export const configsCumulative = ['Head', 'bodyAttributes', 'htmlAttributes'];
